import { render, staticRenderFns } from "./FpuiPackageEditorVersions.vue?vue&type=template&id=12bff0af&lang=pug&"
import script from "./FpuiPackageEditorVersions.vue?vue&type=script&lang=js&"
export * from "./FpuiPackageEditorVersions.vue?vue&type=script&lang=js&"
import style0 from "./FpuiPackageEditorVersions.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports